/**
 * @generated SignedSource<<11b5541681ecf66eeab86df2c4b2bf49>>
 * @relayHash 95af56e110e262772b7bffecf1da490d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 138fa18f6814f26f850b7ff1e062893078e17be6eff14a953fb031084282194a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentLandingPageQuery } from './VirtualAgentLandingPageQuery.graphql';

import replaceVsaWithRovoAgentsFG_provider from '@atlassian/jira-relay-provider/src/jsm-replace-vsa-with-rovo-agents.relayprovider';
import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';
import showNextStepsEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-va-next-steps.relayprovider';
import vaStatusHeaderEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-va-status-header.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentLandingPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "138fa18f6814f26f850b7ff1e062893078e17be6eff14a953fb031084282194a",
    "metadata": {},
    "name": "VirtualAgentLandingPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": vaStatusHeaderEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvanextstepsrelayprovider": showNextStepsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmreplacevsawithrovoagentsrelayprovider": replaceVsaWithRovoAgentsFG_provider
    }
  }
};

export default node;
